import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {Modal, Space} from 'antd';
import EditInvoiceModal from '../EditInvoiceModal';
import MatchedTransactionDetails from '../MatchedTransactionDetails';
import PayNowForm from '../PayNowForm';
import TransactionMatchingPanel from '../TransactionMatchingPanel';
import PaymentSuccessMessage from '../../../PaymentSuccessMessage';

const panelTypes = {
  MATCHING: 'matching',
  PAYMENT: 'payment',
};

const {MATCHING, PAYMENT} = panelTypes;

const TransactionMatchEditor = ({
  activePanelType,
  isAvailableSuggested = true,
  isDefinedTransaction = false,
  invoice,
  loading = false,
  matchedTransaction,
  onCloseFilter,
  onEditModalOk,
  onFilter,
  onNext,
  onPaymentSuccess,
  onSelectTransaction,
  transactions = { searched: [], suggested: [] },
}) => {
  const [isOpenEditInvoiceModal, setIsOpenEditInvoiceModal] = useState(false);

  const isPaymentMode = useMemo(() => activePanelType === PAYMENT, [activePanelType]);

  const isMatchingMode = useMemo(() => activePanelType === MATCHING, [activePanelType]);

  const [isOpenPaymentSuccessModal, setIsOpenPaymentSuccessModal] = useState(false);

  const handleCancelEditModal = () => setIsOpenEditInvoiceModal(false);

  const handleEdit = () => setIsOpenEditInvoiceModal(true);

  const handleOkEditModal = () => {
    handleCancelEditModal();
    onEditModalOk?.();
  }

  const handleSuccessPaymentCreation = (invoice) => {
    onPaymentSuccess?.(invoice);
    setIsOpenPaymentSuccessModal(true);
  }

  const handleClosePaymentSuccessModal = () => {
    setIsOpenPaymentSuccessModal(false);
    onNext?.();
  }

  return (
    <>
      <Space direction='vertical' size='small'>
        {isDefinedTransaction ? (
          <MatchedTransactionDetails
            invoice={invoice}
            onEdit={handleEdit}
            transaction={matchedTransaction}
          />
        ) : (
          <>
            {isPaymentMode && (
              <PayNowForm
                clearAfterSubmit={false}
                invoice={invoice}
                onSuccess={handleSuccessPaymentCreation}
              />
            )}
            {isMatchingMode && (
              <TransactionMatchingPanel
                invoice={invoice}
                isAvailableUnselect={false}
                isAvailableSuggested={isAvailableSuggested}
                loading={loading}
                onClose={onCloseFilter}
                onSelect={onSelectTransaction}
                onFilter={onFilter}
                transactions={transactions}
              />
            )}
          </>
        )}
      </Space>

      <EditInvoiceModal
        onCancel={handleCancelEditModal}
        onOk={handleOkEditModal}
        open={isOpenEditInvoiceModal}
      />

      <Modal
        centered
        footer={null}
        onCancel={handleClosePaymentSuccessModal}
        open={isOpenPaymentSuccessModal}
        title={null}
        width={390}
      >
        <PaymentSuccessMessage onClose={handleClosePaymentSuccessModal} />
      </Modal>
    </>
  );
};

TransactionMatchEditor.propTypes = {
  activePanelType: PropTypes.string,
  isAvailableSuggested: PropTypes.bool,
  isDefinedTransaction: PropTypes.bool,
  invoice: PropTypes.object,
  loading: PropTypes.bool,
  matchedTransaction: PropTypes.object,
  onCloseFilter: PropTypes.func,
  onEditModalOk: PropTypes.func,
  onFilter: PropTypes.func,
  onNext: PropTypes.func,
  onPaymentSuccess: PropTypes.func,
  onSelectTransaction: PropTypes.func,
  showSearchInitially: PropTypes.bool,
  transactions: PropTypes.shape({
    searched: PropTypes.array,
    suggested: PropTypes.array,
  }),
};

export default TransactionMatchEditor;
